import type { AttributesEntity } from '@eliadmin/core/src/api/products/types/product-types';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { IoMdCheckmark } from 'react-icons/io';

export default function ProductVariantColor({ attribute }: { attribute: AttributesEntity }) {
  const selectedValues = useVariantsStore(state => state.selectedValues);
  const updateSelectedValue = useVariantsStore(state => state.updateSelectedValue);

  return (
    <div className={cn('flex items-start justify-start gap-2', 'ea-product-detail-variant__color')}>
      {attribute.values?.map((value, i) => {
        const selected = selectedValues.some(
          selectedValue =>
            selectedValue.attribute.id === attribute.id && selectedValue.value.id === value.id,
        );
        return (
          <div
            key={`color-attribute-${i}`}
            onClick={() => {
              updateSelectedValue({ attribute, value });
            }}
            className={cn(
              'relative h-8 w-8 cursor-pointer rounded-full',
              'ea-product-detail-variant__color-content',
              selected && 'outline-black',
            )}
            style={{ backgroundColor: value.color! }}
          >
            {selected && (
              <IoMdCheckmark
                size={20}
                className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 text-white"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
